'use client';

import { Card, CardContent, Typography, CardActionArea, Box, Theme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface CategoryCardProps {
  id: string;
  label: string;
  description?: string;
  selected?: boolean;
  onClick: (id: string) => void;
  multiSelect?: boolean;
}

export default function CategoryCard({
  id,
  label,
  description,
  selected = false,
  onClick,
  multiSelect = false,
}: CategoryCardProps) {
  return (
    <Card
      sx={{
        position: 'relative',
        height: '100%',
        border: (theme: Theme) =>
          selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: (theme: Theme) => theme.shadows[4],
        },
      }}
    >
      <CardActionArea onClick={() => onClick(id)} sx={{ height: '100%', p: 1 }}>
        <CardContent>
          <Typography variant="h6" component="div" gutterBottom>
            {label}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </CardContent>
        {selected && (
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'primary.main',
            }}
          >
            <CheckCircleIcon />
          </Box>
        )}
      </CardActionArea>
    </Card>
  );
}
